module.exports = __webpack_public_path__ + "img/JDCQSSC.png";